import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NoneLoginHeaderComponent } from '../shared/components/none-login-header/none-login-header.component';
import { NoneLoginFooterComponent } from '../shared/components/none-login-footer/none-login-footer.component';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [CommonModule, NoneLoginHeaderComponent, NoneLoginFooterComponent]
})
export class NotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
